import api from "./Api";

class RestauranteCustoEntregaService {
  GetRestauranteCustoEntregaOData(payload) {
    return api
      .get("/OData/RestauranteCustoEntrega" + payload)
      .then((response) => response.data);
  }
}

export default new RestauranteCustoEntregaService();
